import BookingAdministrativeInformation from "@/components/BookingsDetails/BookingAdministrativeInformation";
import AdditionalStaffInformation from "./AdditionalStaffInformation";

const StaffAdministrativeInformation = ({startingPoint = ""}) => {
    return(
        <>
            {/* PCI's StaffInterface.asp renders StaffExtra's "Additional
                Staff Information" section right before "Staff
                Administrative Information" — same order here. */}
            <AdditionalStaffInformation startingPoint={startingPoint} />
            <BookingAdministrativeInformation
                showHeaderLabel
                headerLabel="Staff Administrative Information"
                parentKey="staff"
                startingPoint={startingPoint}
            />
        </>
    )
}
export default StaffAdministrativeInformation;